import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { UserDataService } from '../users/user-data.service';
import { User } from '../models/models.lib';

export const usersResolver: ResolveFn<User[]> = (route, state) => {
  return inject(UserDataService).getUsers();
};
